import { render } from "./RestorePasswordChange.vue?vue&type=template&id=7e513f9a"
import script from "./RestorePasswordChange.vue?vue&type=script&lang=js"
export * from "./RestorePasswordChange.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__